<div class="event-line" [class.event-line--excluded]="excluded()">
	<mat-checkbox
		class="event-count-checkbox"
		[checked]="!excluded()"
		[disabled]="disabled()"
		(change)="onCountedChange($event.checked)"
		matTooltip="Czy liczyć ten wpis do rozliczenia"
		matTooltipPosition="above"
		aria-label="Liczyć do rozliczenia"
	></mat-checkbox>
	<a class="event-dates" [routerLink]="['/tourism-events', eventId()]">
		{{ dateFrom() | date: 'd MMM, HH:mm' }}
		<span class="event-dash">–</span>
		{{ dateTo() | date: 'd MMM, HH:mm' }}
	</a>
	<span class="event-amount" [class.event-amount--excluded]="excluded()">
		<ng-content></ng-content>
	</span>
	@if (excluded()) {
		<span class="settlement-badge settlement-badge-excluded">Wykluczone</span>
	}
</div>
@if (excluded() || commentValue()) {
	<mat-form-field appearance="outline" class="event-comment-field" subscriptSizing="dynamic">
		<mat-label>Powód wykluczenia (opcjonalnie)</mat-label>
		<input
			matInput
			maxlength="500"
			[disabled]="disabled()"
			[ngModel]="commentValue()"
			(ngModelChange)="onCommentInput($event)"
		/>
	</mat-form-field>
}
